import { ModalProps } from "antd/lib/modal";

export const emailModalProps: ModalProps = {
  footer: null,
  maskClosable: false,
  width: `100%`,
  style: { maxWidth: 760 },
  wrapClassName: "email-send-modal",
};

export const fullWidthModalProps: ModalProps = {
  footer: null,
  maskClosable: true,
  width: `100%`,
  style: { maxWidth: `calc(100vw - 40px)` },
  wrapClassName: "email-send-modal",
};

export const emailSendModal: ModalProps = {
  footer: null,
  maskClosable: false,
  width: "100%",
  style: { maxWidth: 1200, top: 20 },
  styles: { body: { overflow: "hidden" } },
  // className: 'full-height-modal'
};
